<template>
  <div class="card card-chart">
    <div class="card-header bg-white">
      <h5 class="card-title">Chat</h5>
    </div>
    <div class="card-body">
      <!-- Content wrapper start -->

      <!-- Content wrapper end -->

      <div class="d-lg-flex">
        <div class="chat-leftsidebar me-lg-4">
          <div class="">
            <div class="py-4 border-bottom">
              <div class="media">
                <div class="align-self-center me-3">
                  <img
                    :src="user.image.primary"
                    class="rounded-circle header-profile-user mr-1"
                  />
                </div>
                <div class="media-body">
                  <h5 class="font-size-15 mt-0 mb-1">
                    {{
                      this.user.name
                        .toLowerCase()
                        .split(" ")
                        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                        .join(" ")
                    }}
                  </h5>
                  <p
                    :class="
                      onlineStatus === true
                        ? ' badge badge-soft-success mb-0'
                        : ' badge badge-soft-warning mb-0'
                    "
                  >
                    <i
                      class="mdi mdi-circle text-success align-middle me-1"
                    ></i>
                    <span v-if="onlineStatus === true">Online</span>
                    <span v-else
                      >Menghubungkan <i class="fa fa-spinner"></i
                    ></span>
                  </p>
                </div>
              </div>
            </div>

            <div class="chat-leftsidebar-nav">
              <div class="tab-content py-4">
                <div class="tab-pane show active" id="chat">
                  <div>
                    <h5 class="font-size-14 mb-3">All Conversation</h5>
                    <ul
                      class="list-unstyled chat-list"
                      data-simplebar="init"
                      style="max-height: 410px"
                    >
                      <!-- <li class="active">
                        <a id="listPeople">
                          <div class="media">
                            <div class="align-self-center me-3">
                              <i class="mdi mdi-circle font-size-10"></i>
                            </div>
                            <div class="align-self-center me-3">
                              <img
                                src="https://placeimg.com/640/480/animals"
                                class="rounded-circle avatar-xs"
                                alt=""
                              />
                            </div>

                            <div class="media-body overflow-hidden">
                              <h5 class="text-truncate font-size-14 mb-1">
                                test
                              </h5>
                              <p class="text-truncate mb-0">test</p>
                            </div>
                            <div class="font-size-11">05 min</div>
                          </div>
                        </a>
                      </li> -->
                      <template v-for="(cust, index) in roomChat">
                        <li class="active" :key="index">
                          <a
                            id="listPeople"
                            @click="appendMessages(cust)"
                            :data-id="cust.customerId"
                          >
                            <div class="media">
                              <div class="align-self-center me-3">
                                <i class="mdi mdi-circle font-size-10"></i>
                              </div>
                              <div class="align-self-center me-3">
                                <img
                                  src="@/assets/upload/empty_avatar.png"
                                  class="
                                    rounded-circle
                                    header-profile-user
                                    mr-1
                                  "
                                />
                              </div>
                              <div class="media-body overflow-hidden">
                                <h5
                                  class="text-truncate mb-1"
                                  style="font-size: 12px"
                                >
                                  {{ cust.customerName }}
                                </h5>
                                <p>
                                  <!-- {{ cust.countUnread }} -->
                                </p>
                                <!-- <p
                                  class="text-truncate mb-0"
                                  style="font-size: 12px"
                                >
                                  {{
                                    cust.messages.length !== 0
                                      ? cust.messages[cust.messages.length - 1]
                                          .text
                                      : ""
                                  }}
                                </p> -->
                              </div>
                              <div class="font-size-11" style="font-size: 12px">
                                <span
                                  v-if="cust.countUnread !== 0"
                                  class="badge badge-soft-info rounded-circle"
                                  >{{ cust.countUnread }}</span
                                >

                                <!-- {{
                                  cust.messages.length !== 0
                                    ? cust.messages[cust.messages.length - 1]
                                        .time
                                    : ""
                                }} -->
                              </div>
                            </div>
                          </a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 user-chat">
          <div class="text-center" v-if="!isClicked" style="margin-top: 100px">
            <img
              src="@/assets/upload/chat.png"
              width="450px"
              height="350px"
              alt=""
            />
            <p class="card-title">No Conversation</p>
            <p class="text-muted">
              Once you start a new conversation, you'll see it listen here
            </p>
          </div>
          <div class="card" v-if="isClicked">
            <div class="p-4 border-bottom">
              <div class="row">
                <div class="col-md-4 col-9">
                  <h5 class="font-size-15 mb-1">{{ custName }}</h5>
                  <p class="text-muted mb-0">
                    <i
                      class="mdi mdi-circle text-success align-middle me-1"
                    ></i>
                    Active now
                  </p>
                </div>
              </div>
            </div>

            <div>
              <div class="chat-conversation p-3">
                <ul
                  class="list-unstyled mb-0"
                  data-simplebar="init"
                  style="max-height: 486px"
                >
                  <div class="simplebar-wrapper" style="margin: 0px">
                    <div class="simplebar-height-auto-observer-wrapper">
                      <div class="simplebar-height-auto-observer"></div>
                    </div>
                    <div class="simplebar-mask">
                      <div
                        class="simplebar-offset"
                        style="right: -17px; bottom: 0px"
                      >
                        <div
                          class="simplebar-content-wrapper scrollable"
                          style="height: auto; overflow: hidden scroll"
                        >
                          <div class="simplebar-content" style="padding: 0px">
                            <li>
                              <!-- <div class="chat-day-title">
                                                                <span class="title">Today</span>
                                                            </div> -->
                            </li>
                            <div class="row">
                              <div class="col-md-12">
                                <template v-for="(chat, index) in listMessage">
                                  <li
                                    :class="
                                      chat.role === 'customer'
                                        ? 'left'
                                        : 'right'
                                    "
                                    :key="index"
                                  >
                                    <div class="conversation-list">
                                      <div class="ctext-wrap">
                                        <div
                                          class="
                                            conversation-name
                                            font-weight-bold
                                          "
                                        >
                                          {{
                                            chat.role === "seller"
                                              ? "You"
                                              : chat.customerName
                                          }}
                                        </div>
                                        <p style="white-space: pre-line">
                                          {{ chat.text }}
                                        </p>
                                        <p class="chat-time mb-0">
                                          <i
                                            class="
                                              bx bx-time-five
                                              align-middle
                                              me-1
                                            "
                                          ></i
                                          >{{ chat.time }}
                                        </p>
                                      </div>
                                    </div>
                                  </li>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="simplebar-placeholder"
                      style="width: auto; height: 645px"
                    ></div>
                  </div>
                  <div
                    class="simplebar-track simplebar-horizontal"
                    style="visibility: hidden"
                  >
                    <div
                      class="simplebar-scrollbar"
                      style="
                        transform: translate3d(0px, 0px, 0px);
                        display: none;
                      "
                    ></div>
                  </div>
                  <div
                    class="simplebar-track simplebar-vertical"
                    style="visibility: visible"
                  >
                    <div
                      class="simplebar-scrollbar"
                      style="
                        height: 353px;
                        transform: translate3d(0px, 0px, 0px);
                        display: block;
                      "
                    ></div>
                  </div>
                </ul>
              </div>

              <div class="p-3 chat-input-section">
                <div class="row">
                  <div class="col">
                    <div class="position-relative">
                      <textarea
                        id="sendMessage"
                        class="col"
                        rows="3"
                        placeholder="Tulis Pesan..."
                        v-model="message"
                      />
                      <!-- <div class="chat-input-links" id="tooltip-container">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a href="#" title="Emoji"
                              ><i class="far fa-smile-beam"></i
                            ></a>
                          </li>
                          <li class="list-inline-item">
                            <a href="#" title="Images"
                              ><i class="far fa-file-image"></i
                            ></a>
                          </li>
                          <li class="list-inline-item">
                            <a href="#" title="Add Files"
                              ><i class="far fa-file-alt"></i
                            ></a>
                          </li>
                        </ul>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-auto">
                    <button
                      type="submit"
                      @click="sendMessage()"
                      class="
                        btn btn-primary btn-rounded
                        chat-send
                        w-md
                        waves-effect waves-light
                      "
                    >
                      <span class="d-none d-sm-inline-block me-2"></span>
                      <i class="fa fa-send"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notification from "/src/components/ToastComponent/Notification.vue";
import $ from "jquery";
import { mapGetters } from "vuex";

import firebase from "firebase/app";

// const db = firebase.firestore();

// /* eslint-disable no-unused-vars */
export default {
  component: {
    Notification,
  },
  data() {
    return {
      message: "",
      roomChat: [],
      listMessage: [],
      custName: "",
      custId: "",
      isClicked: false,
      setRoom: "",
      firstUser: 0,
      onlineStatus: false,
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
    }),
  },
  watch: {
    // listMessage() {
    //   this.getUsers();
    // this.getRoom();
    // },
  },
  updated() {
    // this.getSyncRoom();
    // this.getUsers();
    // this.getRoom();
    this.getRoom();
  },
  created() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      firebase
        .database()
        .ref(`/unread-message/seller/${this.user.id}`)
        .on("value", () => {
          fetch(
            `https://siplah.eurekabookhouse.co.id/api_chat/get-users?id=${this.user.id}&from=seller`
          )
            .then((res) => {
              return res.json();
            })
            .then((data) => {
              this.roomChat = data;
              this.firstUser = this.roomChat[0].customerId;
              this.onlineStatus = true;
            })
            .catch(() => {
              this.onlineStatus = false;
            });
        });
    },
    getRoom() {
      if (this.roomChat.length === 0) {
        return false;
      } else {
        firebase
          .database()
          .ref(`/contact/seller`)
          .on("value", () => {
            fetch(
              `https://siplah.eurekabookhouse.co.id/api_chat/room?customerId=${this.firstUser}&sellerId=${this.user.id}`
            )
              .then((res) => res.json())
              .then((data) => {
                this.setRoom = data.room;
              });
          });
      }
    },
    getSyncRoom() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/api_chat/room?customerId=${this.custId}&sellerId=${this.user.id}`
      )
        .then((res) => res.json())
        .then((data) => {
          this.setRoom = data.room;
        });
    },
    readChatApi() {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=9nobp6qp3ffpg6sp92h96tv4m9eraos8");

      var formdata = new FormData();
      formdata.append("customerId", this.custId);
      formdata.append("seller_id", this.user.id);
      formdata.append("role", "customer");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(
        "https://siplah.eurekabookhouse.co.id/staging/backendseller/Mychat/readChat",
        requestOptions
      ).then(() =>
        firebase
          .database()
          .ref(`/unread-message/seller/${this.user.id}`)
          .set(`${this.createRandomString()}`)
      );
    },
    async appendMessages(param) {
      this.custId = param.customerId;
      this.isClicked = true;
      firebase
        .database()
        .ref(`/contact/seller`)
        .on("value", () => {
          fetch(
            `https://siplah.eurekabookhouse.co.id/api_chat/message?customerId=${this.custId}&sellerId=${this.user.id}`
          )
            .then((res) => {
              // this.getSyncRoom();
              return res.json();
            })
            .then((data) => {
              setTimeout(() => {
                $(".scrollable")
                  .stop()
                  .animate(
                    {
                      scrollTop: $(".scrollable")[0].scrollHeight,
                    },
                    1000
                  );
              }, 550);
              this.listMessage = data;
              setTimeout(() => {
                this.readChatApi();
              }, 1000);
              // console.log(data);
            });
        });

      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=9nobp6qp3ffpg6sp92h96tv4m9eraos8");

      var formdata = new FormData();
      formdata.append("customerId", this.custId);
      formdata.append("seller_id", this.user.id);
      formdata.append("role", "customer");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(
        "https://siplah.eurekabookhouse.co.id/staging/backendseller/Mychat/readChat",
        requestOptions
      ).then(() =>
        firebase
          .database()
          .ref(`/unread-message/seller/${this.user.id}`)
          .set(`${this.createRandomString()}`)
      );
    },
    messages() {
      // const sellerId = this.user.id;
      // socket.emit(
      //   "message",
      //   { customerId: this.custId, sellerId },
      //   (messages) => {
      //     // console.count(messages[messages.length -1], messages[messages.length -1])
      //     this.listMessage = messages;
      //   }
      // );
    },
    createRandomString() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return new String(uuid);
    },
    reFetchListMessage() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/api_chat/message?customerId=${this.custId}&sellerId=${this.user.id}`
      )
        .then((res) => {
          // this.getSyncRoom();
          return res.json();
        })
        .then((data) => {
          $(".scrollable")
            .stop()
            .animate(
              {
                scrollTop: $(".scrollable")[0].scrollHeight,
              },
              10
            );
          this.listMessage = data;
          // console.log(data);
        });
    },
    sendMessage() {
      firebase
        .database()
        .ref(`/unread-message/customer/${this.custId}`)
        .set(`${this.createRandomString()}`);
      firebase
        .database()
        .ref(`/contact/customer/${this.setRoom}`)
        .set(`${this.createRandomString()}`);

      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=dd52o33rn6c2gn1256kn14t9t7m1eeko");
      var formdata = new FormData();
      formdata.append("customerId", this.custId);
      formdata.append("seller_id", this.user.id);
      formdata.append("message", $("#sendMessage").val());
      formdata.append("role", "seller");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      fetch(
        "https://siplah.eurekabookhouse.co.id/staging/backendseller/mychat/addchattoRoom",
        requestOptions
      ).then(() => {
        this.reFetchListMessage();
        this.message = "";
      });
    },
  },
};
</script>

<style scoped>
.dot {
  height: 15px;
  width: 15px;
  background-color: rgb(105, 129, 143);
  border-radius: 100%;
  display: inline-block;
  color: #fff;
  padding: 1.5px 0px 0px 4.4px;
  font-size: 10px;
}
.me-lg-4 {
  margin-right: 1.5rem !important;
}

.d-lg-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}

.chat-leftsidebar {
  /* min-width: 260px; */
  max-width: 100%;
  width: 300px;
}
.me-lg-4 {
  margin-right: 1.5rem !important;
}
.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.border-bottom {
  border-bottom: 1px solid #eff2f7 !important;
}
.media {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.me-3 {
  margin-right: 1rem !important;
}
.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}
.avatar-xs {
  height: 2rem;
  width: 2rem;
}
.rounded-circle {
  border-radius: 50% !important;
}
img,
svg {
  vertical-align: middle;
}

.media-body {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.font-size-15 {
  font-size: 15px !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.mt-0 {
  margin-top: 0 !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.position-relative {
  position: relative !important;
}

.chat-search-box .form-control {
  border: 0;
}
.search-box .form-control {
  border-radius: 30px;
  padding-left: 40px;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.47rem 0.75rem;
  padding-left: 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}
button,
input,
optgroup,
select,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.chat-leftsidebar .chat-leftsidebar-nav .nav {
  background-color: #fff;
}
.nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
dl,
ol,
ul {
  margin-top: 0;
  margin-bottom: 1rem;
}
ol,
ul {
  padding-left: 2rem;
}
.nav-justified .nav-item,
.nav-justified > .nav-link {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: center;
}
.nav-justified .nav-item,
.nav-justified > .nav-link {
  text-align: center;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #556ee6;
}
.nav-pills .nav-link {
  background: 0 0;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills > li > a,
.nav-tabs > li > a {
  color: #495057;
  font-weight: 500;
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}
a,
button {
  outline: 0 !important;
}
a {
  text-decoration: none !important;
}
a {
  color: #556ee6;
  text-decoration: none;
}
.d-sm-block {
  display: block !important;
}
.d-none {
  display: none !important;
}
*,
::after,
::before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
}
.nav-pills > li > a,
.nav-tabs > li > a {
  color: #495057;
  font-weight: 500;
}

.chat-leftsidebar .chat-leftsidebar-nav .tab-content {
  min-height: 488px;
}
.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.tab-content > .active {
  display: block;
}
.chat-list {
  margin: 0;
}
[data-simplebar] {
  position: relative;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-height-auto-observer-wrapper {
  -webkit-box-sizing: inherit !important;
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  -webkit-box-flex: inherit;
  -ms-flex-positive: inherit;
  flex-grow: inherit;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
}
.simplebar-height-auto-observer {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}
.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}
.simplebar-offset {
  direction: inherit !important;
  -webkit-box-sizing: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content::after,
.simplebar-content::before {
  content: " ";
  display: table;
}
.chat-list li.active a {
  background-color: #fff;
  border-color: transparent;
  -webkit-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
.chat-list li a {
  display: block;
  padding: 14px 16px;
  color: #74788d;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
  border-top: 1px solid #eff2f7;
  border-top-color: rgb(239, 242, 247);
  border-radius: 4px;
}
.simplebar-content::after,
.simplebar-content::before {
  content: " ";
  display: table;
}
.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}
.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}
.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}
.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}
.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 4px;
  min-height: 10px;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}
.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}
.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 4px;
  min-height: 10px;
}
.simplebar-track.simplebar-vertical .simplebar-scrollbar::before {
  top: 2px;
  bottom: 2px;
}
.simplebar-scrollbar::before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}
.w-100 {
  width: 100% !important;
}
.card {
  margin-bottom: 24px;
  -webkit-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
.card {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid #f6f6f6;
  border-radius: 0.25rem;
}
.p-4 {
  padding: 1.5rem !important;
}
.border-bottom {
  border-bottom: 1px solid #eff2f7 !important;
}
.row {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) / -2);
  margin-left: calc(var(--bs-gutter-x) / -2);
}
.font-size-15 {
  font-size: 15px !important;
}

.text-end {
  text-align: right !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.list-inline {
  padding-left: 0;
  list-style: none;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
.d-sm-inline-block {
  display: inline-block !important;
}
[data-simplebar] {
  position: relative;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}
.simplebar-height-auto-observer-wrapper {
  -webkit-box-sizing: inherit !important;
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  -webkit-box-flex: inherit;
  -ms-flex-positive: inherit;
  flex-grow: inherit;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
}
.simplebar-height-auto-observer {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}
.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}
.simplebar-offset {
  direction: inherit !important;
  -webkit-box-sizing: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}
.simplebar-content-wrapper {
  direction: inherit;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  width: auto;
  visibility: visible;
  overflow: auto;
  max-width: 100%;
  max-height: 100%;
  scrollbar-width: thin;
  padding: 0 !important;
}
.simplebar-content-wrapper {
  direction: inherit;
  visibility: visible;
}
.simplebar-offset {
  direction: inherit !important;
}
.simplebar-mask {
  direction: inherit;
}
.simplebar-content::after,
.simplebar-content::before {
  content: " ";
  display: table;
}
.chat-conversation li {
  clear: both;
}

.chat-conversation .right .conversation-list {
  float: right;
  width: 50%;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-block;
  position: relative;
  width: 50%;
}
.chat-conversation .right .conversation-list .dropdown {
  float: left;
  width: 50%;
}
.chat-conversation .conversation-list .dropdown {
  float: right;
}
.dropdown,
.dropend,
.dropstart,
.dropup {
  position: relative;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle {
  font-size: 18px;
  padding: 4px;
  color: #74788d;
}
.dropdown-toggle {
  white-space: nowrap;
}
[role="button"] {
  cursor: pointer;
}
.chat-conversation .right .conversation-list .ctext-wrap {
  background-color: #eff2f7;
  text-align: right;
  border-radius: 8px 8px 0 8px;
}
.chat-conversation .conversation-list .ctext-wrap {
  padding: 12px 24px;
  background-color: rgba(85, 110, 230, 0.1);
  border-radius: 8px 8px 8px 0;
  overflow: hidden;
}
.chat-conversation .conversation-list .ctext-wrap .conversation-name {
  font-weight: 500;
  color: #556ee6;
  margin-bottom: 4px;
}
.chat-conversation .conversation-list .chat-time {
  font-size: 12px;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-block;
  position: relative;
}
.chat-conversation .right .conversation-list {
  float: right;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-block;
  position: relative;
}
.chat-conversation .right .conversation-list .ctext-wrap {
  background-color: #eff2f7;
  text-align: right;
  border-radius: 8px 8px 0 8px;
}
.chat-conversation .conversation-list .ctext-wrap {
  padding: 12px 24px;
  background-color: rgba(85, 110, 230, 0.1);
  border-radius: 8px 8px 8px 0;
  overflow: hidden;
}
.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}
simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}
.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}
.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}
.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}
.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 4px;
  min-height: 10px;
}
.simplebar-scrollbar::before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}
.chat-input-section {
  border-top: 1px solid #eff2f7;
}
.chat-input {
  border-radius: 30px;
  background-color: #eff2f7 !important;
  border-color: #eff2f7 !important;
  padding-right: 120px;
}
.chat-input-links {
  position: absolute;
  right: 16px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
.chat-input-links li a {
  font-size: 16px;
  line-height: 36px;
  padding: 0 4px;
  display: inline-block;
}
</style>
